export const GET_API_KEYS = 'getApiKeys'
export const CREATE_API_KEY = 'createApiKey'
export const DELETE_API_KEY = 'deleteApiKey'

export const TAG_API_KEYS = 'TAG_API_KEYS'
export default [TAG_API_KEYS]
